<template>
	
	<article class="video-tile">
		<div class="video-heading">
			<h3 class="title is-3 flex-middle">
				<a :href="video.url">{{video.title}}</a>
			</h3>
			<div class="share">
				<social-network-sharing></social-network-sharing>
			</div>
		</div>
		<a :href="video.url">
			<div class="video-container">
				<div class="play-overlay flex-middle-center"><i class="fas fa-play-circle"></i></div>
				<img class="placeholder" :src="video.mediaUrl"/>
			</div>
		</a>
		<p>{{video.caption}}</p>
	</article>
	
</template>
	
<script>
	import SocialNetworkSharing from '../SocialNetworkSharing.vue';

	export default {
		name: "VideoTile",
		props: ["video"],
		components: { SocialNetworkSharing }
	}
</script>
